import firebaseConfig from "../FirebaseConfig";
import{initializeApp} from 'firebase/app'
const app = initializeApp(firebaseConfig);

export default app;